module.exports = __webpack_public_path__ + "img/going-digital__icon.39047df0.png";